import React from 'react';
import I18n from 'lib/i18n/i18n';
import {dollarsWithoutCents, imageUrl} from 'helpers/ApplicationHelper';


const SoldItemPreview = (props) => {
    const soldFor = !props.hideSoldFor? <p className="sold-for">
                        {I18n.getString('components::soldItemPreview::soldFor')+ ' '}
                        <b>{dollarsWithoutCents(props.item.sold_for)}</b>
                    </p> : null;
    return (
        <div className="sold-item-preview">
            { ['listingPage', 'cui'].includes(props.page) ? <div className='sold-item-preview__photo' style={{ backgroundImage: 'url(' + (props.item.thumb || imageUrl(props.page === 'listingPage' ? 'common/photo-placeholder-grey.svg' : 'common/photo-placeholder.svg')) + ')'}}/> : <img src={props.item.thumb || imageUrl('common/photo-placeholder.svg')}/> }
            {soldFor}
            <p className="item-desc"> {props.item.desc} </p>
        </div>
    );
}

export default SoldItemPreview;